export const getAccordion = ({ spaces }) => ({
  item: {
    padding: spaces[3],
    body: {
      mt: spaces[4],
    },
  },
})
